export enum ERoutePaths {
  HOME = '/',
  LOGIN = '/login',
  PROFILE = '/profile',
  DASHBOARD = '/dashboard',
  TENANTS = '/tenants',
  TENANT_EDIT = '/tenants/:tenantId',
  SUBSCRIPTIONS = '/subscriptions',
  SUBSCRIPTION_EDIT = '/subscriptions/:subscriptionId',
  FEATURES = '/features',
  FEATURE_EDIT = '/features/:featureId',
  ADMIN_MARKETPLACE = '/admin/marketplace',
  ADMIN_MARKETPLACE_FEATURES = '/admin/marketplace/features',
  CREDITS = '/credits',
  REVENUE = '/revenue',
  ENTITLEMENTS = '/entitlements',
  NOT_FOUND = '*',
}
